// extracted by mini-css-extract-plugin
export default {"manageTags":"ManageTags_manageTags__KxCadTrp"};